







import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import BackToMenuButton from '@/components/menu/button/BackToMenuButton.vue';

@Component({
  components: {
    BackToMenuButton,
  },
})
export default class ButtonPanel extends Vue {
  @Prop({default: true})
  private menu!: boolean;
}
